import { Chip, Box, Typography, Tooltip } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const PendingReceiptsChip = ({ count = 0 }) => {
  const isCritical = count > 4;
  const isWarning = count > 0;

  const getColor = () => {
    if (isCritical) return "error";
    if (isWarning) return "warning";
    return "success";
  };
  if (count === 0) return;

  const getLabel = () => {
    if (count === 1) return "1 pendiente";
    return `${count} pendientes`;
  };

  return (
    <Tooltip title="Recibos que estan en estado pendiente">
      <Box>
        <Chip
          icon={isWarning ? <WarningAmberIcon /> : null}
          label={
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography fontWeight={600} fontSize={13}>
                {getLabel()}
              </Typography>
            </Box>
          }
          color={getColor()}
          variant={count === 0 ? "outlined" : "filled"}
          sx={{
            borderRadius: "16px",
            px: 1,
            fontWeight: 600,
            boxShadow: count > 0 ? 2 : 0,
            transition: "0.2s",
            "&:hover": {
              transform: "translateY(-1px)",
              boxShadow: 3,
            },
          }}
        />
      </Box>
    </Tooltip>
  );
};

export default PendingReceiptsChip;
